import React from "react";
import { contact } from "../../mock";
import { MessageCircle, Send, Zap } from "lucide-react";

const CTASection = () => {
  return (
    <section className="py-20 md:py-24 relative overflow-hidden">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden border border-[#00ff87]/25 bg-gradient-to-br from-[#0c1a14] via-[#0a0a13] to-[#0a1620] p-10 md:p-16 text-center">
          <div className="glow-blob w-72 h-72 bg-[#00ff87] -top-20 -left-10" />
          <div className="glow-blob w-72 h-72 bg-[#00e5ff] -bottom-20 -right-10" />
          <div className="relative z-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#00ff87]/10 border border-[#00ff87]/30 text-[#00ff87] text-xs font-semibold mb-5">
              <Zap size={14} /> Start Today
            </span>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight">
              Get your <span className="neon-green text-glow-green">Online Cricket ID</span> in 2 minutes
            </h2>
            <p className="mt-5 text-gray-300 max-w-2xl mx-auto">
              Fastest cricket id · Best odds in the market · Instant withdrawals · 24/7 support. You're just one message away from the action.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <a href={contact.whatsapp} target="_blank" rel="noreferrer" className="btn-neon inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl font-display font-semibold">
                <MessageCircle size={20} /> WhatsApp Now
              </a>
              <a href={contact.telegram} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-xl font-display font-semibold border border-[#00e5ff]/40 text-[#00e5ff] hover:bg-[#00e5ff]/10 transition-colors">
                <Send size={20} /> Telegram
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
